/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalControlsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalControlsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalControlsQuery = {
  __typename?: 'Query';
  internalControls: {
    __typename: 'InternalControlConnection';
    edges: Array<{
      __typename: 'InternalControlEdge';
      cursor: string;
      node: { __typename: 'InternalControl'; id: string; code: string; latestName?: string | null };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalControlsDocument = gql`
  query InternalControls($input: InternalControlsInput, $first: Int, $after: String) {
    internalControls(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          code
          latestName
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalControlsQuery__
 *
 * To run a query within a React component, call `useInternalControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalControlsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalControlsQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalControlsQuery, IInternalControlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalControlsQuery, IInternalControlsQueryVariables>(InternalControlsDocument, options);
}
export function useInternalControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IInternalControlsQuery, IInternalControlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalControlsQuery, IInternalControlsQueryVariables>(
    InternalControlsDocument,
    options,
  );
}
// @ts-ignore
export function useInternalControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IInternalControlsQuery, IInternalControlsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalControlsQuery, IInternalControlsQueryVariables>;
export function useInternalControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalControlsQuery, IInternalControlsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalControlsQuery | undefined, IInternalControlsQueryVariables>;
export function useInternalControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalControlsQuery, IInternalControlsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalControlsQuery, IInternalControlsQueryVariables>(
    InternalControlsDocument,
    options,
  );
}
export type InternalControlsQueryHookResult = ReturnType<typeof useInternalControlsQuery>;
export type InternalControlsLazyQueryHookResult = ReturnType<typeof useInternalControlsLazyQuery>;
export type InternalControlsSuspenseQueryHookResult = ReturnType<typeof useInternalControlsSuspenseQuery>;
export type InternalControlsQueryResult = Apollo.QueryResult<IInternalControlsQuery, IInternalControlsQueryVariables>;
